import { APIConfiguration } from '@savgroup-front-common/configuration';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SearchOrderDetailsDto,
} from '@savgroup-front-common/types';

export const ENDPOINT = `${APIConfiguration.owner}orders/${COMMON_QUERY_PARAMS.ORDER_ID}/details`;

export interface GetOrderDetailsQueryArgs {
  orderId: string;
}

export const getOrderDetailsRequest = (
  payload: GetOrderDetailsQueryArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.ORDER_ID, payload.orderId),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getOrderDetailsQuery(
  payload: GetOrderDetailsQueryArgs,
): Promise<BackResponse<SearchOrderDetailsDto> | BackResponseFailure> {
  try {
    return await executeQuery<BackResponse<SearchOrderDetailsDto>>(
      getOrderDetailsRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default getOrderDetailsQuery;
